import React from 'react'
// import DefaultIcon from  '@material-ui/icons/Layers'
import SmartIceIcon from '@material-ui/icons/AcUnit'
import SmartIceQamutikIcon from '@material-ui/icons/Motorcycle'
import Tooltip from '@material-ui/core/Tooltip'

const tooltipWrapper = (label, icon) => (
  <Tooltip id={label} title={label} placement='left'>
    {icon}
  </Tooltip>
)

const height = '1em'

const layers = {
  SmartIce: {
    icon: <SmartIceIcon style={{ color: 'lightBlue', height: height }} />,
    label: 'Ice travel'
  },
  SmartIceQamutik: {
    icon: <SmartIceQamutikIcon style={{ color: 'orange', height: height }} />,
    label: 'Qamutik'
  }
}

const lookupLayerIcon = layerName => {
  const layer = layers[layerName]
  return layer ? tooltipWrapper(layer.label, layer.icon) : <div />
}

export default lookupLayerIcon



// WEBPACK FOOTER //
// ./src/utility/lookupLayerIcon.js